// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetAuthData, GetAuthResponse, GetCandlesData, GetCandlesResponse, GetDeltaSignalData, GetDeltaSignalResponse, GetPricesData, GetPricesResponse, GetSgManifestResponse, GetSgTnsContractsData, GetSgTnsContractsResponse, GetSgTnsFeedData, GetSgTnsFeedResponse, GetSgTnsFlowSumData, GetSgTnsFlowSumResponse, GetSgTnsHighlightsData, GetSgTnsHighlightsResponse, GetStatusData, GetStatusResponse, GetStreamData, GetV1CorrelationRegimeData, GetV1CorrelationRegimeResponse, GetV1EquitiesBySymsData, GetV1EquitiesBySymsResponse, PostV1MoviefoneChatData, PostV1MoviefoneChatResponse, PostV1MoviefoneChatFollowupData, PostV1MoviefoneChatFollowupResponse, GetV1MoviefoneConversationsResponse, PostV1MoviefoneConversationsData, PostV1MoviefoneConversationsResponse, GetV1MoviefoneConversationsByTimestampData, GetV1MoviefoneConversationsByTimestampResponse, DeleteV1MoviefoneConversationsByTimestampData, DeleteV1MoviefoneConversationsByTimestampResponse, PostV1MoviefoneExtractStructureRequestData, PostV1MoviefoneExtractStructureRequestResponse, GetV1OpeningSetupPositionMovesData, GetV1OpeningSetupPositionMovesResponse, GetV1OpeningSetupProfilesData, GetV1OpeningSetupProfilesResponse, GetV1OpeningSetupVolScannerData, GetV1OpeningSetupVolScannerResponse, GetV1SettlementStyleData, GetV1SettlementStyleResponse, PostV1SpotlineAnalysisData, PostV1SpotlineAnalysisResponse, GetV1SpotlineTopTradesData, GetV1SpotlineTopTradesResponse, GetV2DailyGreeksData, GetV2DailyGreeksResponse, GetV2LatestGreeksData, GetV2LatestGreeksResponse, GetV2OpenInterestIntradayDeltaData, GetV2OpenInterestIntradayDeltaResponse, GetV2OpenInterestIntradayGammaData, GetV2OpenInterestIntradayGammaResponse, GetV2OpenInterestIntradayStatsData, GetV2OpenInterestIntradayStatsResponse, GetV2OpenInterestIntradayStrikeBarsData, GetV2OpenInterestIntradayStrikeBarsResponse, GetV2OpenInterestIntradayTimestampsData, GetV2OpenInterestIntradayTimestampsResponse, GetValidateBearerResponse, GetVixQuoteData, GetVixQuoteResponse } from './types.gen';

export class DefaultService {
    /**
     * The handler for the auth request which generates a token to validate based on basic client
     * ID/secret authentication
     * @param data The data for the request.
     * @param data.authorization Basic Authentication
     * @returns string Success
     * @throws ApiError
     */
    public static getAuth(data: GetAuthData): CancelablePromise<GetAuthResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth',
            headers: {
                authorization: data.authorization
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sym
     * @param data.stream
     * @param data.field
     * @param data.option
     * @param data.filter
     * @param data.limit
     * @param data.start start timestamp in milliseconds
     * @param data.end end timestamp in milliseconds
     * @returns string Success
     * @throws ApiError
     */
    public static getCandles(data: GetCandlesData): CancelablePromise<GetCandlesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/candles',
            query: {
                sym: data.sym,
                stream: data.stream,
                field: data.field,
                option: data.option,
                filter: data.filter,
                limit: data.limit,
                start: data.start,
                end: data.end
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.symbol
     * @param data.optionAccumulationType
     * @param data.optionOrigin
     * @param data.isFiltered
     * @param data.candleDurationMs duration of candles. Must be a multiple of 5000
     * @param data.timeGte ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
     * @param data.timeLt ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
     * @param data.limit max number of items to return. Default 100, max 20_000
     * @returns DeltaSignalRsp Success
     * @throws ApiError
     */
    public static getDeltaSignal(data: GetDeltaSignalData): CancelablePromise<GetDeltaSignalResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/delta_signal',
            query: {
                symbol: data.symbol,
                option_accumulation_type: data.optionAccumulationType,
                option_origin: data.optionOrigin,
                is_filtered: data.isFiltered,
                time_gte: data.timeGte,
                time_lt: data.timeLt,
                candle_duration_ms: data.candleDurationMs,
                limit: data.limit
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.symbol
     * @param data.candleDurationMs duration of candles. Must be a multiple of 5000
     * @param data.timeGte ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
     * @param data.timeLt ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
     * @param data.limit max number of items to return. Default 100, max 20_000
     * @param data.order order the candles are fetched and returned in. Default "asc"
     * @returns CandlesRsp Success
     * @throws ApiError
     */
    public static getPrices(data: GetPricesData): CancelablePromise<GetPricesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/prices',
            query: {
                symbol: data.symbol,
                time_gte: data.timeGte,
                time_lt: data.timeLt,
                candle_duration_ms: data.candleDurationMs,
                limit: data.limit,
                order: data.order
            }
        });
    }
    
    /**
     * Fetches the list of available instruments for the day
     * @returns Manifest
     * @throws ApiError
     */
    public static getSgManifest(): CancelablePromise<GetSgManifestResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/manifest'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sorting
     * @param data.offset
     * @param data.limit
     * @returns ContractRow Success
     * @throws ApiError
     */
    public static getSgTnsContracts(data: GetSgTnsContractsData = {}): CancelablePromise<GetSgTnsContractsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_contracts',
            query: {
                filters: data.filters,
                sorting: data.sorting,
                offset: data.offset,
                limit: data.limit
            }
        });
    }
    
    /**
     * The handler for the Time & Sales feed
     * @param data The data for the request.
     * @param data.filters
     * @param data.sorting
     * @param data.offset
     * @param data.limit
     * @returns string Success
     * @throws ApiError
     */
    public static getSgTnsFeed(data: GetSgTnsFeedData = {}): CancelablePromise<GetSgTnsFeedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_feed',
            query: {
                filters: data.filters,
                sorting: data.sorting,
                offset: data.offset,
                limit: data.limit
            }
        });
    }
    
    /**
     * The handler for the Time & Sales flow summary. Aggregate: volume, premium, delta, gamma, vega
     * @param data The data for the request.
     * @param data.filters
     * @returns HiroAggSummary Success
     * @throws ApiError
     */
    public static getSgTnsFlowSum(data: GetSgTnsFlowSumData = {}): CancelablePromise<GetSgTnsFlowSumResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_flow_sum',
            query: {
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.start
     * @param data.end
     * @returns Highlights Success
     * @throws ApiError
     */
    public static getSgTnsHighlights(data: GetSgTnsHighlightsData = {}): CancelablePromise<GetSgTnsHighlightsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_highlights',
            query: {
                start: data.start,
                end: data.end
            }
        });
    }
    
    /**
     * Health and build information for the server instance handling the request.
     * Always reports the deployed commit (`repo_git_hash`). Sending a bearer token additionally
     * reports whether it decoded (`able_to_decode_jwt`), and a token carrying the `administrator`
     * role also reports the instance hostname plus a live reachability probe of each backing
     * service (Redis cluster, users/hiro/crunchy Postgres, Scylla, S3) - any probe that fails turns
     * the response into a 500 while still returning the per-service detail.
     * @param data The data for the request.
     * @param data.authorization Bearer <jwt-token>
     * @returns ServerStatus Success
     * @throws ApiError
     */
    public static getStatus(data: GetStatusData): CancelablePromise<GetStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/status',
            headers: {
                authorization: data.authorization
            }
        });
    }
    
    /**
     * The handler for the HTTP request (this gets called when the HTTP GET lands at the start
     * of websocket negotiation). After this completes, the actual switching from HTTP to
     * websocket protocol will occur.
     * This is the last point where we can extract TCP/IP metadata such as IP address of the client
     * as well as things from HTTP headers such as user-agent of the browser etc.
     * @param data The data for the request.
     * @param data.token
     * @throws ApiError
     */
    public static getStream(data: GetStreamData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/stream',
            query: {
                token: data.token
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sym Symbol to query (e.g., NVDA)
     * @returns CorrelationRegimeResponse Success
     * @throws ApiError
     */
    public static getV1CorrelationRegime(data: GetV1CorrelationRegimeData): CancelablePromise<GetV1CorrelationRegimeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/correlation_regime',
            query: {
                sym: data.sym
            },
            errors: {
                404: 'No data found for symbol',
                500: 'Database error'
            }
        });
    }
    
    /**
     * SpotGamma equity levels and vol metrics by symbol.
     * For each requested symbol, the daily Equity Hub row for the trade date: key levels (call and
     * put walls, key gamma/delta strikes, hedge wall), gamma and delta exposures, option volumes,
     * IV/skew ranks, and per-strike gamma lists - see `EquityLevels` for the full field list.
     * Symbols with no data are omitted from the response. Index-combo aliases (e.g. `S&P 500`,
     * `Nasdaq`) resolve to their index's levels; `S&P ES=F` additionally shifts price-level fields
     * by the index-to-futures offset.
     * @param data The data for the request.
     * @param data.syms Comma-separated list of symbols, e.g. `SPX,AAPL`
     * @param data.date Trade date. If unspecified, defaults to today; either way the most recent payload within
     * the prior 5 business days is served.
     * @returns EquityLevels Map of requested symbol to its equity-levels row
     * @throws ApiError
     */
    public static getV1EquitiesBySyms(data: GetV1EquitiesBySymsData): CancelablePromise<GetV1EquitiesBySymsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/equities_by_syms',
            query: {
                syms: data.syms,
                date: data.date
            },
            errors: {
                403: 'A requested symbol requires Pro membership'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown SSE stream of chat completion deltas
     * @throws ApiError
     */
    public static postV1MoviefoneChat(data: PostV1MoviefoneChatData): CancelablePromise<PostV1MoviefoneChatResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/moviefone/chat',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Missing or invalid required field',
                403: 'Query rejected by the gatekeeper model',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns MoviefoneChatFollowupRsp Non-streaming chat completion
     * @throws ApiError
     */
    public static postV1MoviefoneChatFollowup(data: PostV1MoviefoneChatFollowupData): CancelablePromise<PostV1MoviefoneChatFollowupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/moviefone/chat/followup',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Missing or invalid required field',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * @returns MoviefoneConversationSummary The caller's saved conversations, most recently updated first
     * @throws ApiError
     */
    public static getV1MoviefoneConversations(): CancelablePromise<GetV1MoviefoneConversationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/moviefone/conversations',
            errors: {
                403: 'Account has no WordPress ID to look up conversations under',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.xMoviefoneTitle Base64-encoded (UTF-8 before encoding) title for the conversation, stored as an S3 object tag
     * @param data.requestBody Raw JSON conversation payload - streamed straight through to storage, not parsed or validated server-side
     * @param data.xMoviefoneTimestamp An existing conversation's timestamp, to overwrite it instead of creating a new one
     * @param data.xMoviefoneInteracted Set to "true" when this save was directly triggered by the user (asking something) rather than a response simply finishing - controls whether it moves in the list.
     * @returns MoviefoneConversationSummary The stored conversation's identifying metadata
     * @throws ApiError
     */
    public static postV1MoviefoneConversations(data: PostV1MoviefoneConversationsData): CancelablePromise<PostV1MoviefoneConversationsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/moviefone/conversations',
            headers: {
                'x-moviefone-title': data.xMoviefoneTitle,
                'x-moviefone-timestamp': data.xMoviefoneTimestamp,
                'x-moviefone-interacted': data.xMoviefoneInteracted
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Missing/empty `x-moviefone-title` header, or an invalid `x-moviefone-timestamp` header',
                403: 'Account has no WordPress ID to store conversations under',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.timestamp The conversation's timestamp identifier, as returned by store/list
     * @returns unknown The full conversation, brotli-compressed (Content-Encoding: br) so it can be streamed straight through to the browser
     * @throws ApiError
     */
    public static getV1MoviefoneConversationsByTimestamp(data: GetV1MoviefoneConversationsByTimestampData): CancelablePromise<GetV1MoviefoneConversationsByTimestampResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/moviefone/conversations/{timestamp}',
            path: {
                timestamp: data.timestamp
            },
            errors: {
                403: 'Account has no WordPress ID to look up conversations under',
                404: 'No conversation with that timestamp belonging to the caller',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.timestamp The conversation's timestamp identifier, as returned by store/list
     * @returns void The conversation was deleted
     * @throws ApiError
     */
    public static deleteV1MoviefoneConversationsByTimestamp(data: DeleteV1MoviefoneConversationsByTimestampData): CancelablePromise<DeleteV1MoviefoneConversationsByTimestampResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/moviefone/conversations/{timestamp}',
            path: {
                timestamp: data.timestamp
            },
            errors: {
                403: 'Account has no WordPress ID to delete conversations under',
                404: 'No conversation with that timestamp belonging to the caller',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Interprets a user's latest prompt for updates to their Trade Criteria/StructureRequest
     * @param data The data for the request.
     * @param data.requestBody
     * @returns StructureRequestExtractionRsp The trade criteria updates in the user's prompt
     * @throws ApiError
     */
    public static postV1MoviefoneExtractStructureRequest(data: PostV1MoviefoneExtractStructureRequestData): CancelablePromise<PostV1MoviefoneExtractStructureRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/moviefone/extract-structure-request',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Missing or invalid required field',
                403: 'Query rejected by the gatekeeper model',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * Unusual options positioning (position moves) from the Flow Patrol Opening Setup report.
     * Large opening option positions detected for the report date, enriched with premiums,
     * open-interest changes, IV/skew ranks, and probability of payoff, ordered by absolute
     * premium (largest first). Multileg legs are included and share a multileg_id.
     * @param data The data for the request.
     * @param data.date Report date. If unspecified, the most recent date with data is served.
     * @returns PositionMovesRsp Position moves (unusual flows) for the report date, ordered by absolute premium
     * @throws ApiError
     */
    public static getV1OpeningSetupPositionMoves(data: GetV1OpeningSetupPositionMovesData = {}): CancelablePromise<GetV1OpeningSetupPositionMovesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/opening_setup/position_moves',
            query: {
                date: data.date
            },
            errors: {
                404: 'No data for the requested date'
            }
        });
    }
    
    /**
     * Setup Profiles picks from the Flow Patrol Opening Setup report.
     * Four vol-surface-screened trade-idea picks for the report date - Bull (flattest put
     * skew), Bear (steepest put skew), Short Vol (highest IV/RV), and Long Vol (lowest
     * IV/RV) - each a single symbol from the liquid, earnings-clean universe with its
     * screening metrics and a human-readable play description.
     * @param data The data for the request.
     * @param data.date Report date. If unspecified, the most recent date with data is served.
     * @returns SetupProfilesRsp Setup Profiles picks for the report date
     * @throws ApiError
     */
    public static getV1OpeningSetupProfiles(data: GetV1OpeningSetupProfilesData = {}): CancelablePromise<GetV1OpeningSetupProfilesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/opening_setup/profiles',
            query: {
                date: data.date
            },
            errors: {
                404: 'No data for the requested date'
            }
        });
    }
    
    /**
     * Implied-vol scanner from the Flow Patrol Opening Setup report.
     * The most active option names for the report date (ranked by option volume) with current
     * and prior front-month IV, day-over-day IV change, IV rank/percentile vs trailing
     * history, and a practical-read classification of the vol setup.
     * @param data The data for the request.
     * @param data.date Report date. If unspecified, the most recent date with data is served.
     * @returns VolScannerRsp Most-active-options vol scanner for the report date, ordered by option volume
     * @throws ApiError
     */
    public static getV1OpeningSetupVolScanner(data: GetV1OpeningSetupVolScannerData = {}): CancelablePromise<GetV1OpeningSetupVolScannerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/opening_setup/vol_scanner',
            query: {
                date: data.date
            },
            errors: {
                404: 'No data for the requested date'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.symbol
     * @returns SettlementStyleResponse Exercise style per expiry date for one underlying
     * @throws ApiError
     */
    public static getV1SettlementStyle(data: GetV1SettlementStyleData): CancelablePromise<GetV1SettlementStyleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/settlement_style',
            query: {
                symbol: data.symbol
            },
            errors: {
                401: 'Missing or invalid authentication',
                404: 'Symbol absent from the IPF style map'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.riskFreeRate
     * @param data.requestBody
     * @returns MoviefoneAnalysis Runs and retreives analysis of
     * @throws ApiError
     */
    public static postV1SpotlineAnalysis(data: PostV1SpotlineAnalysisData): CancelablePromise<PostV1SpotlineAnalysisResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/spotline/analysis',
            query: {
                risk_free_rate: data.riskFreeRate
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Missing or invalid required field',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.riskFreeRate
     * @returns SpotlineTopTradesRsp Top-ranked trade for each of today's Opening Setup profiles
     * @throws ApiError
     */
    public static getV1SpotlineTopTrades(data: GetV1SpotlineTopTradesData): CancelablePromise<GetV1SpotlineTopTradesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/spotline/top_trades',
            query: {
                risk_free_rate: data.riskFreeRate
            },
            errors: {
                404: 'No Opening Setup profiles available',
                500: 'Internal server error'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sym If unspecified, defaults to SPX
     * @param data.date If unspecified, defaults to SPX
     * @param data.mktClose If unspecified, defaults to true
     * @returns unknown message-packed expiry strike map
     * @throws ApiError
     */
    public static getV2DailyGreeks(data: GetV2DailyGreeksData = {}): CancelablePromise<GetV2DailyGreeksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/daily_greeks',
            query: {
                sym: data.sym,
                date: data.date,
                mkt_close: data.mktClose
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sym
     * @returns unknown message-packed expiry strike map
     * @throws ApiError
     */
    public static getV2LatestGreeks(data: GetV2LatestGreeksData): CancelablePromise<GetV2LatestGreeksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/latest_greeks',
            query: {
                sym: data.sym
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.symbol
     * @param data.mktActor
     * @param data.date
     * @param data.ts
     * @returns unknown Success
     * @throws ApiError
     */
    public static getV2OpenInterestIntradayDelta(data: GetV2OpenInterestIntradayDeltaData): CancelablePromise<GetV2OpenInterestIntradayDeltaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/open_interest/intraday_delta',
            query: {
                symbol: data.symbol,
                date: data.date,
                ts: data.ts,
                mkt_actor: data.mktActor
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.symbol
     * @param data.mktActor
     * @param data.date
     * @param data.ts
     * @returns unknown Success
     * @throws ApiError
     */
    public static getV2OpenInterestIntradayGamma(data: GetV2OpenInterestIntradayGammaData): CancelablePromise<GetV2OpenInterestIntradayGammaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/open_interest/intraday_gamma',
            query: {
                symbol: data.symbol,
                date: data.date,
                ts: data.ts,
                mkt_actor: data.mktActor
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sym
     * @param data.date
     * @returns unknown Success
     * @throws ApiError
     */
    public static getV2OpenInterestIntradayStats(data: GetV2OpenInterestIntradayStatsData): CancelablePromise<GetV2OpenInterestIntradayStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/open_interest/intraday_stats',
            query: {
                sym: data.sym,
                date: data.date
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.barType
     * @param data.symbol
     * @param data.date
     * @returns unknown Success
     * @throws ApiError
     */
    public static getV2OpenInterestIntradayStrikeBars(data: GetV2OpenInterestIntradayStrikeBarsData): CancelablePromise<GetV2OpenInterestIntradayStrikeBarsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/open_interest/intraday_strike_bars',
            query: {
                symbol: data.symbol,
                bar_type: data.barType,
                date: data.date
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.greek
     * @param data.mktActor
     * @param data.symbol
     * @param data.date
     * @returns unknown Success
     * @throws ApiError
     */
    public static getV2OpenInterestIntradayTimestamps(data: GetV2OpenInterestIntradayTimestampsData): CancelablePromise<GetV2OpenInterestIntradayTimestampsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/open_interest/intraday_timestamps',
            query: {
                symbol: data.symbol,
                greek: data.greek,
                date: data.date,
                mkt_actor: data.mktActor
            }
        });
    }
    
    /**
     * A simple handler for validating and inspecting a JWT token
     * @returns Claims Success
     * @throws ApiError
     */
    public static getValidateBearer(): CancelablePromise<GetValidateBearerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validate_bearer'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.dates
     * @returns Page_VixQuote Success
     * @throws ApiError
     */
    public static getVixQuote(data: GetVixQuoteData = {}): CancelablePromise<GetVixQuoteResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/vix_quote',
            query: {
                dates: data.dates
            }
        });
    }
    
}